<script lang="ts">
  import type { ProjectTableItem } from "@kontextwerk/control-web-client"
  import EvaluationChartsSection from "@kontextwerk/control-web-frame/shared/modules/evaluation-charts-section"
  import type { OrgaViewFrameContext } from "../../../../context"
  import { canViewAnalytics, canViewPlanningStatistics, type PageContext } from "../../navigation"
  import { fetchOrganizationProjectTable } from "../../../../../../api/kehrblatt/projects"
  import PlanningStatistics from "./_modules/planning-statistics"

  const { viewFrameContext, pageContext } = $props<{
    viewFrameContext: OrgaViewFrameContext
    pageContext: PageContext
  }>()

  const organizationId = $derived(pageContext.organization?.id ?? null)
  const analyticsAllowed = $derived(
    viewFrameContext.tariffCapabilities.hasAnalytics && canViewAnalytics(pageContext.permissions),
  )
  const planningAllowed = $derived(canViewPlanningStatistics(pageContext.permissions))
  let projectResponse = $state<{ organizationId: string; items: ProjectTableItem[] } | null>(null)
  const projects = $derived(
    projectResponse?.organizationId === organizationId ? projectResponse.items : [],
  )

  $effect(() => {
    const requestedOrganizationId = organizationId

    if (!requestedOrganizationId || !analyticsAllowed) return

    let current = true
    void fetchOrganizationProjectTable(requestedOrganizationId).then(
      (items) => {
        if (current) projectResponse = { organizationId: requestedOrganizationId, items }
      },
      (error) => {
        if (current) {
          projectResponse = null
          console.error("kehrblatt_statistics_project_options_load_failed", error)
        }
      },
    )

    return () => {
      current = false
    }
  })
</script>

<div class="overview-statistics">
  {#if organizationId}
    {#if planningAllowed}
      <PlanningStatistics {organizationId} />
    {/if}
    {#if analyticsAllowed}
      {#key organizationId}
        <EvaluationChartsSection
          title="Gesprächsauswertungen"
          description="Bewertungen und Qualitätsmetriken aus den Sessions."
          {projects}
          enableProjectFilter={true}
          headerSmall={true}
        />
      {/key}
    {/if}
  {/if}
</div>

<style>
  .overview-statistics {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    min-width: 0;
    width: 100%;
  }
</style>
